module.exports = __webpack_public_path__ + "static/img/driblab_white_box_pro.698fe0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/driblab_white_box_pro.png
// module id = +u1U
// module chunks = 94